'use strict';

var takeUntil = function takeUntil(array, fn) {
  var index = array.findIndex(fn);
  if (index === -1) {
    return array.slice();
  }
  return array.slice(0, index);
};

module.exports = function (input, fn) {
  if (typeof input === 'string') {
    return takeUntil(input.split(''), fn).join('');
  }
  return takeUntil(input, fn);
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/iterable/takeUntil.js
// module id = 727
// module chunks = 37